import { Box, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { COLOR1, ORIENTAL_D_GRAY } from '../../../constants';
import { businessMapping } from '../../../services/businessMapping';
import { productTypeMapping } from '../../../services/productTypeMapping';
import { isBundle } from '../../commonCode';
import { DownArrowIcon } from '../../../images/svg/CustomizedSVG';

const selectInputs = {
  background: 'rgba(85, 88, 88, 0.02) 0% 0% no-repeat padding-box',
  opacity: 1,
  height: '41px',
  fontWeight: 300,
  fontStyle: 'normal',
  fontSize: '14px',
  lineHeight: '16px',
  textAlign: 'left',
  letterSpacing: '0.1px',
  color: COLOR1,
  width: '95%',
  '& .MuiOutlinedInputInput': {
    padding: '11.5px 14px',
  },
  [`& fieldset`]: {
    borderRadius: '1px',
    border: `0.25px solid ${ORIENTAL_D_GRAY}`,
  },
};

const labelTitle = {
  marginBottom: '8px',
  font: 'normal normal bold 14px/17px Arial',
  letterSpacing: '0.1px',
  color: COLOR1,
  textAlign: 'left',
  marginTop: '10px',
};

function GroupSubOption({ parent, component, question }) {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { productName, theme } = leadGenerationContext;

  const [translation, setTranslation] = useState(leadGenerationContext.productQuestionsEN);
  useEffect(() => {
    if (leadGenerationContext.language === 'EN') {
      setTranslation(leadGenerationContext.productQuestionsEN);
    }
    if (leadGenerationContext.language === 'ES') {
      setTranslation(leadGenerationContext.productQuestionsES);
    }
  }, [leadGenerationContext.language]);
  const onHandleChange = (event) => {
    if (
      businessMapping(leadGenerationContext.productName) &&
      (productTypeMapping(leadGenerationContext.productType) === 'Checking Account' ||
        productTypeMapping(leadGenerationContext.productType) === 'Savings Account')
    ) {
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    leadGenerationContext.setIsScreenFiveDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);
    if (
      isBundle(productName) &&
      leadGenerationContext.productTabVal === 0 &&
      !leadGenerationContext.productAccountType
    ) {
      leadGenerationContext.setFormAnswerSavings({
        ...leadGenerationContext.formAnswerSavings,
        [event.target.name]: event.target.value,
      });
    } else if (
      (isBundle(productName) && leadGenerationContext.productTabVal === 1) ||
      !isBundle(productName) ||
      leadGenerationContext.productAccountType
    ) {
      leadGenerationContext.setFormAnswer({
        ...leadGenerationContext.formAnswer,
        [event.target.name]: event.target.value,
      });
    }
  };

  return component.subComponents.map((subComponent) => {
    const label = `${question.name}_${component.label}_${subComponent.label}`;
    return (
      <Grid key={subComponent.label} size={{ xs: 12, md: 6 }}>
        <InputLabel
          id={`${parent}_${label}_label`}
          style={labelTitle}
          aria-label={translation[subComponent.label]}
        >
          {translation[subComponent.label]}
        </InputLabel>
        <Select
          fullWidth
          variant="outlined"
          id={`${parent}_${label}`}
          data-testid="select_testid"
          name={label}
          IconComponent={() => (
            <Box padding="0 10px 0 0">
              <DownArrowIcon
                style={{ width: 24, height: 24 }}
                color={theme?.palette?.orientalPrimary?.main}
              />
            </Box>
          )}
          aria-label={`${translation[subComponent.label]} ${t(
            'Required Select dropdown menu button',
            { defaultValue: 'Required Select dropdown menu button' }
          )}`}
          defaultValue={subComponent?.options[0]}
          style={selectInputs}
          value={
            leadGenerationContext.formAnswer[label]
              ? leadGenerationContext.formAnswer[label]
              : subComponent?.options[0]
          }
          onChange={onHandleChange}
        >
          {subComponent.options.map((item) => (
            <MenuItem
              key={item}
              value={item}
              aria-label={t(translation[item] ? translation[item] : item, {
                defaultValue: translation[item] ? translation[item] : item,
              })}
            >
              {t(translation[item] ? translation[item] : item, {
                defaultValue: translation[item] ? translation[item] : item,
              })}
            </MenuItem>
          ))}
        </Select>
      </Grid>
    );
  });
}

GroupSubOption.propTypes = {
  parent: PropTypes.object,
  component: PropTypes.object,
  question: PropTypes.object,
};

export default GroupSubOption;
